import { render, staticRenderFns } from "./grammar.vue?vue&type=template&id=54c4f476&scoped=true&"
var script = {}
import style0 from "./grammar.vue?vue&type=style&index=0&id=54c4f476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c4f476",
  null
  
)

export default component.exports